import styled from 'styled-components'
import NextImage from 'next/image'

import Icon from '../Icon'

export const UrpsFact = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Image = styled(NextImage)``
export const IconStyled = styled(Icon)``

export const Value = styled.h3`
  ${({ theme }) => theme.textStyles.bebas3Xl};
  line-height: 2.4rem;
  color: ${({ theme }) => theme.colors.pinkPrimary};
  margin-top: 3rem;
`

export const Text = styled.p`
  ${({ theme }) => theme.textStyles.montserratTextBaseBold}
  margin-top: 2rem;
`
